var React = require('react');

function MobileClosed (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#FFF","fillRule":"evenodd"},[React.createElement("g",{"fillRule":"nonzero","key":0},[React.createElement("path",{"d":"M9.163 6.671l19.292 19.292c.41.41.969.516 1.248.237l1.263-1.263c.279-.28.173-.838-.237-1.247L11.437 4.398c-.41-.41-.968-.516-1.247-.237L8.927 5.424c-.28.28-.174.837.236 1.247z","key":0}),React.createElement("path",{"d":"M30.894 6.5L11.5 25.893c-.412.412-.984.508-1.278.214l-1.33-1.33c-.293-.293-.197-.865.215-1.277L28.5 4.106c.412-.412.984-.508 1.278-.214l1.33 1.33c.293.293.197.865-.215 1.277z","key":1})]),React.createElement("text",{"fontFamily":"'Open Sans', Arial, sans-serif","fontSize":"10","letterSpacing":"-.455","key":1},React.createElement("tspan",{"x":"4.616","y":"36"},"CLOSE"))]));
}

MobileClosed.defaultProps = {"width":"40","height":"40"};

module.exports = MobileClosed;

MobileClosed.default = MobileClosed;
